import { motion } from "framer-motion";

function PageTransition({ children }) {
  return (
<motion.div
initial={{ y: 6 }}
animate={{ y: 0 }}
exit={{ y: 0 }}

transition={{
  duration: 0.14,
  ease: "easeOut",
}}
  style={{ minHeight: "100vh" }}
>
      {children}
    </motion.div>
  );
}

export default PageTransition;